/**
 * 站点统一配置 - 所有页面引用的公司/联系信息唯一来源
 *
 * 替换 App.js / pageFooter / contact 中的硬编码
 * 数据来源：i18n/locales/{zh,en,vi}/translation.json 真实字段 + 代码中确认的真实值
 *
 * 重要：不要在此处添加虚构数据。所有字段都必须有真实出处。
 */

// ====== 真实联系信息（来源：contact/index.js、pageFooter/index.js、App.js） ======
export const HOTLINE = '400-050-1183';              // 全国服务热线
export const FAX = '0769-83236839';                 // 传真
export const EMAIL = 'gnaturepowdef@gmail.com';     // 邮箱
export const MOBILE = '+86 189-2913-1303';          // 手机/WhatsApp
export const WHATSAPP_NUMBER = '8618929131303';     // wa.me 链接用（无 + 号）
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

// ====== 公司名（三语真实数据，来源：translation.json） ======
export const COMPANY_NAME = {
  zh: '龙南小麦自动化科技有限公司',
  en: 'Longnan Xiaomai Automation Technology Co., Ltd.',
  vi: 'Công ty TNHH Công nghệ Tự động hóa Xiaomai Long Nam',
};

// ====== 英文公司名（用于 JSON-LD 知识图谱，三个语种 translation.json 统一值） ======
export const COMPANY_NAME_EN_LEGAL = 'LONGNAN WHEAT AUTOMATION TECHNOLOGY CO., LTD';

// ====== 厂区地址（来源：translation.json *_factory_address_detail） ======
export const DONGGUAN_FACTORY_ADDRESS = {
  zh: '广东省东莞市寮步镇向西工业区旭升路7号厂房一楼',
  en: "1st Floor, Factory Building, NO.7 Xusheng Road, Xiangxi Industrial Zone, Liaobu Town, Dongguan, Guangdong, China",
  vi: 'Tầng 1, Tòa nhà nhà máy, Số 7 Đường Xú Sinh, Khu công nghiệp Xiangxi, Thị trấn Liaobu, Dongguan, Guangdong',
};

export const JIANGXI_FACTORY_ADDRESS = {
  zh: '江西省赣州市龙南市龙南经济技术开发区电子科技产业城 F1-08东侧地块（华立美工业园）',
  en: 'Plot (Hualimei Industrial Park) East of Electronic Science and Technology Industrial City, Longnan Economic and Technological Development Zone, Ganzhou City, Jiangxi Province',
  vi: 'Lô (Khu công nghiệp Hoa Lợi Mỹ) Đông của Khu công nghiệp Khoa học và Công nghệ Điện tử, Khu phát triển Kinh tế và Công nghệ Longnan, Ganzhou, Jiangxi',
};

// ====== 站点信息 ======
// 国内站 www.xiaomaizn.com / 国外站 www.xiaomaitech.com 用同一套代码，
// 构建时用 REACT_APP_SITE_DOMAIN 覆盖（canonical / hreflang / sitemap / robots 都跟着走）
export const DOMAIN = process.env.REACT_APP_SITE_DOMAIN || 'https://www.xiaomaizn.com';

// ====== 路由表（11 个核心页面 × 3 语言 = 33 条 URL） ======
// 用于 react-snap 预渲染 + sitemap 生成
export const ROUTE_SLUGS = [
  '',                  // 首页
  'about',
  'capacity',
  'advantage',
  'products',
  'x5',
  'x6',
  'zm',
  'spreaders_video',
  'purchase_guide',
  'contact',
];

// 语言代码
export const LANGS = ['en', 'zh', 'vi'];   // 顺序：默认语言在前

// 路径前缀映射
export const LANG_PREFIX = {
  en: '/en',     // 英文 /en/about
  zh: '',        // 中文为默认，URL 无前缀（/about）
  vi: '/vi',     // 越南语 /vi/about
};

// 反向映射
export const LANG_FROM_PATH = (pathname) => {
  if (pathname.startsWith('/en/') || pathname === '/en') return 'en';
  if (pathname.startsWith('/zh/') || pathname === '/zh') return 'zh';
  if (pathname.startsWith('/vi/') || pathname === '/vi') return 'vi';
  return 'zh';  // 默认中文（/、/about/、/x5 等无前缀路径）
};
